import React, { Component } from 'react';
// import { Row, Col, Panel, PanelGroup } from 'react-bootstrap';
import { USAGE_TYPE_BUSINESS } from '../constants/backend';
import { bindActionCreators } from 'redux';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import * as BookingActions from '../actions/booking';

import { change } from 'redux-form';
import { userIdSelector } from '../helpers/selectors';
import { getUsageFromContract, setDeepRouterQuery } from '../helpers';

import SearchBookingsHomepageForm from './forms/SearchBookingsHomepageForm';

export class SearchBookingsSolo extends Component {
  constructor(props) {
    super(props);
    this.searchBookings = this.searchBookings.bind(this);
    this.state = {
      initialValues: { usageTypes: USAGE_TYPE_BUSINESS }
    };
  }

  componentWillMount() {
    this.getUsageDefault(this.props.contract);
  }

  componentWillReceiveProps(np) {
    if (np.brand.branded.contract !== this.props.brand.branded.contract) {
      const usage = getUsageFromContract(np.brand.branded.contract);
      this.props.dispatch(change('searchBookings', 'usageTypes', usage));
    }
  }

  getUsageDefault(contract) {
    const _usage = getUsageFromContract(contract);
    this.setState({ initialValues: { usageTypes: _usage } });
  }

  searchBookings(formData) {
    let value = setDeepRouterQuery(formData);
    let str = Object.entries(value)
      .map(([key, val]) => `${key}=${val}`)
      .join('&');
    const { protocol, host } = window.location || {};
    top.location.href = protocol + host + '/book?' + str;
  }

  render() {
    return (
      <div className="searchbookings search-booking-homepage">
        <SearchBookingsHomepageForm
          contract={this.props.contract}
          onSubmit={this.searchBookings}
          classname="search-booking-homepage"
          i18n={this.props.i18n}
          initialValues={this.state.initialValues}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userId: userIdSelector(state),
    i18n: state.i18n,
    brand: state.brand,
    contract: state.brand.branded.contract
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BookingActions,
      dispatch
    },
    dispatch
  );
}

const connectComponent = connect(mapStateToProps, mapDispatchToProps)(SearchBookingsSolo);

export default injectIntl(connectComponent);



/** WEBPACK FOOTER **
 ** ./src/components/SearchBookingsSolo.jsx
 **/